import axiosInstance from './AxiosInstance';

const API_URL = 'subcontractors';

export const getSubcontractors = async () => {
  try {
    const response = await axiosInstance.get(API_URL);
    return response.data;
  } catch (error) {
    console.error('Error fetching subcontractors', error);
    throw error;
  }
};

export const getSubcontractorById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/view/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching subcontractor with id ${id}`, error);
    throw error;
  }
};

export const getSubcontractorByProgram = async (program) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/program/${program}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching subcontractor with program ${program}`, error);
    throw error;
  }
};

export const getSubcontractorPrograms = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/programs`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subcontractor programs', error);
    throw error;
  }
};

export const getSubcontractorsForMe = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/me`);
    return response.data;
  } catch (error) {
    console.error('Error fetching subcontractors for current user', error);
    throw error;
  }
};

export const createSubcontractor = async (subcontractor) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/add`, subcontractor);
    return response.data;
  } catch (error) {
    console.error('Error creating subcontractor', error);
    throw error;
  }
};

export const updateSubcontractor = async (id, subcontractor) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...subcontractor });
    return response.data;
  } catch (error) {
    console.error(`Error updating subcontractor with id ${id}`, error);
    throw error;
  }
};

export const deleteSubcontractor = async (id) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
    return response.data;
  } catch (error) {
    console.error(`Error deleting subcontractor with id ${id}`, error);
    throw error;
  }
};
